export enum ProviderSetsRequestType {
  Unknown = "unknown",
  NetworkProviders = "networkProviders",
  ArchivedNetworkProviders = "archivedNetworkProviders",
  SharedProviders = "sharedProviders",
  SystemProviders = "systemProviders",
  SourceProviders = "sourceProviders",
}

export enum ProviderSetType {
  Unknown = "unknown",
  Standard = "standard",
  MA = "ma",
  CCIIO = "cciio",
  PACAID = "pacaid",
  NJDOBI = "njdobi",
  NYSDOH = "nysdoh",
  CADMHC = "cadmhc",
  ProviderSearch = "providerSearch",
  ILCAID = "ilcaid",
  Ameritas = "ameritas",
  TXCAID = "txcaid",
  NMCAID = "nmcaid",
  CACDI = "cacdi",
  NJDMAHS = "njdmahs",
  AccessReporting = "accessReporting"
}

export enum ProviderSetDataSortColumn {
  Unknown = "unknown",
  NPI = "npi",
  Name = "name",
  Address = "address",
  SpecCode = "specCode",
}

export enum ProviderSetVersionSummaryType {
  Unknown = "unknown",
  ByState = "byState",
  ByCountySSA = "byCountySSA",
  BySpecCode = "bySpecCode",
  ByGeocode = "byGeocode",
  SpecCodeCountBreakdown = "specCodeCountBreakdown",
  AddressCountBreakdown = "addressCountBreakdown",
  ByNPIInspection = "ByNPIInspection",
  NoFilter = "noFilter"
}

export enum ProviderSetVersionStatusEnum {
  Created = "created",
  UploadComplete = "uploadComplete",
  GeocodeComplete = "geocodeComplete",
  DataProcessing = "dataProcessing",
  Activated = "activated",
  Archived = "archived"
}

export enum ProviderSetVersionValidationStatusEnum {
  Unknown = "unknown",
  Processing = "processing",
  Passed = "passed",
  Invalid = "invalid",
  Failed = "failed",
  Queued = "queued"
}

export enum TableTypeEnum {
  Unknown = 0,
  NetworkProviders = 1,
  ProspectProviders = 2,
  MarketProviders = 3,
  ProviderTerminations = 4,
  AccuracyProviders = 5,
  NextClosestNetworkProviders = 6,
  NextClosestProspectProviders = 7,
  NextClosestMarketProviders = 8,
}